module.exports = __webpack_public_path__ + "media/SoccerScene_FULL_v4.8f061b29.mp4";